export default "__VITE_ASSET__B$n4dLwS__"